import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Funções do Sistema ", -1)
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_4 = { class: "table-responsive mb-4" }
const _hoisted_5 = { class: "table table-striped table-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " id "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Descrição "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Rotas "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Status ")
  ])
], -1)
const _hoisted_7 = { class: "btn-group mr-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      ($setup.acesso.btnInsert)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/newfuncao/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}`,
            class: "btn btn-sm btn-outline-secondary",
            title: "Nova Função"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file" })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createTextVNode(" Total Registro: " + _toDisplayString($setup.dados.totalreg), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        class: "form-control",
        placeholder: "Procurar Nome ou Descrição",
        onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (funcao) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: funcao.id
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_7, [
                  ($setup.acesso.btnAlter)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/funcoes/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${funcao.id}/edit`,
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Alterar Função"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  ($setup.acesso.btnDelete)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Ativar Função",
                        onClick: ($event: any) => ($setup.ativar(funcao.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  ($setup.acesso.btnDelete)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Inativar Função",
                        onClick: ($event: any) => ($setup.inativar(funcao.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "thumbs-down" })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(funcao.id), 1),
              _createElementVNode("td", null, _toDisplayString(funcao.short_name), 1),
              _createElementVNode("td", null, _toDisplayString(funcao.long_name), 1),
              _createElementVNode("td", null, _toDisplayString(funcao.route), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(funcao.status===1 ? 'badge bg-primary d-block' : 'badge bg-danger d-block')
                }, _toDisplayString(funcao.status===1 ? ' Ativo ' : 'Inativo'), 3)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    ($setup.page < $setup.lastPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}